import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

import { Popup } from '../Popup';
import PriceHistory from './PriceHistory';
import { PriceSubscriptionButton } from '../Controls/Subscriptions';

class PriceHistoryPopup extends Component {
  constructor (props) {
    super(props);

    this.state = {
      opened: false
    };

    this.history = this.props.history;

    this.handleOpenPopup = this.handleOpenPopup.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.autoclosable && this.state.opened !== prevState.opened) {
      if (this.state.opened) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  }

  componentWillUnmount () {
    this.props.autoclosable && document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const nodeRef = findDOMNode(this.popupContainer);
    if (this.popupContainer !== e.target && nodeRef && !nodeRef.contains(e.target) && this.state.opened) {
      this.setState({ opened: false });
    }
  }

  handleOpenPopup (e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.onClickOpen && !this.state.opened) {
      this.props.onClickOpen();
    }

    this.setState({
      opened: !this.state.opened
    });
  }

  renderHistory () {
    return (
      <Popup
        opened={this.state.opened}
        direction='bottom-right'
        mainOffset={0}
        secondaryOffset={0}
        ref={p => { this.popupContainer = p; }}
      >
        <div className='corner-top' />
        <div
          className='history-content'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <PriceHistory history={this.history} previewLine={5} fixedHeight />
          <PriceSubscriptionButton
            dealType={this.props.dealType}
            realtyType={this.props.realtyType}
            realtyId={this.props.realtyId} />
        </div>
      </Popup>
    );
  }

  render () {
    if (!this.history) {
      return this.props.children && <div className='price-label no-history'>{ this.props.children }</div>;
    }

    const trendClass = this.history.getTrend();
    const trend = trendClass === 'up' ? '\ue931' : '\ue930';

    return (
      <div className='price-history-popup' onClick={this.handleOpenPopup}>
        <div className='price-label yes-history'>
          {this.props.children}
          <span data-tip data-for='tip-price-history' className={'trend trend-after ' + trendClass}>{trend}</span>
        </div>

        {this.state.opened && this.renderHistory()}
      </div>
    );
  }
}

PriceHistoryPopup.propTypes = {
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  realtyId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,

  history: PropTypes.object,
  autoclosable: PropTypes.bool,
  children: PropTypes.any,

  onClickOpen: PropTypes.func
};

PriceHistoryPopup.defaultProps = {
  history: null,
  autoclosable: true,
  children: null,

  onClickOpen: () => {}
};

export default PriceHistoryPopup;



// WEBPACK FOOTER //
// ./src/ui/Price/PriceHistoryPopup.jsx